module.exports = __webpack_public_path__ + "img/Hero.656ad591.jpg";